export function AgentUsecasePreviewIllustration() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="440" height="246" fill="none" viewBox="0 0 440 246">
      <rect width="151.976" height="38.776" x="144.012" y="4.359" stroke="#f2f5f8" strokeWidth=".968" rx="7.26" />
      <rect width="146.168" height="32.968" x="146.916" y="7.266" fill="#fff" rx="4.356" />
      <rect width="146.168" height="32.968" x="146.916" y="7.266" stroke="#e1e4ea" strokeWidth=".968" rx="4.356" />
      <path
        stroke="#cacfd8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M163.4 21.08v-2.666h-2.667m-4 6.667h1.334m10.666 0h1.334m-4.667-.667v1.333m-4-1.333v1.333m-2-4.666h8c.736 0 1.333.597 1.333 1.333v5.333c0 .737-.597 1.334-1.333 1.334h-8a1.333 1.333 0 0 1-1.333-1.334v-5.333c0-.736.597-1.333 1.333-1.333"
      />
      <rect width="74.536" height="5.808" x="177.4" y="16.445" fill="url(#a)" rx="2.904" />
      <rect width="30.728" height="5.808" x="253.872" y="16.445" fill="url(#b)" rx="2.904" />
      <rect width="88.088" height="5.808" x="177.4" y="25.25" fill="url(#c)" rx="2.904" />
      <rect width="64.776" height="18.904" x="235.965" y=".484" fill="#fff" rx="3.388" />
      <rect width="64.776" height="18.904" x="235.965" y=".484" stroke="#f2f5f8" strokeWidth=".968" rx="3.388" />
      <path
        fill="#0e121b"
        d="M241.735 12.938v-2.604l-2.101-4.463h1.084l1.249 2.672q.126.261.203.493.078.223.107.349.02-.126.097-.349.087-.232.203-.493l1.22-2.672h1.084l-2.101 4.463v2.604zm6.269.096q-.659 0-1.143-.242a1.8 1.8 0 0 1-.735-.716 2.3 2.3 0 0 1-.252-1.104V7.837q0-.64.252-1.103.261-.465.735-.707.484-.252 1.143-.252.657 0 1.132.252.484.242.736.707.261.465.261 1.093v3.147q0 .629-.261 1.103-.252.464-.736.716-.474.242-1.132.242m0-.929q.532 0 .803-.29.28-.3.281-.842V7.836q0-.551-.281-.842-.271-.29-.803-.29-.523 0-.804.29-.28.29-.281.842v3.137q0 .541.281.842.28.29.804.29m5.746.93q-1.017 0-1.568-.553-.552-.56-.552-1.52v-5.09h1.045v5.09q0 .533.262.843.27.31.813.31.533 0 .803-.31.271-.31.271-.842V5.87h1.046v5.092q0 .958-.552 1.52-.552.55-1.568.551m3.655-.098V5.872h2.217q.667 0 1.161.261.494.252.765.717.28.464.281 1.094 0 .705-.368 1.229a1.92 1.92 0 0 1-.978.726l1.443 3.04h-1.191l-1.287-2.905h-.998v2.905zm1.045-3.823h1.172q.522 0 .832-.31.31-.32.31-.842 0-.542-.31-.852t-.832-.31h-1.172zm10.05 3.823 1.801-7.066h1.374l1.801 7.067h-1.055l-.426-1.791h-2.004l-.426 1.79zm1.685-2.652h1.607l-.484-2.042a78 78 0 0 1-.213-.94q-.077-.405-.107-.551-.029.145-.106.552-.078.396-.213.929zm6.588 2.75q-.659 0-1.152-.243a1.84 1.84 0 0 1-.755-.716 2.25 2.25 0 0 1-.261-1.104V7.837q0-.64.261-1.103.271-.465.755-.707.494-.252 1.152-.252.659 0 1.142.252.484.252.746.716.27.455.271 1.094h-1.046q0-.551-.29-.842t-.823-.29-.832.29q-.291.29-.291.832v3.147q0 .541.291.842.3.3.832.3t.823-.3.29-.842v-.794h-1.316v-.92h2.362v1.713q0 .63-.271 1.094-.262.465-.746.717-.483.25-1.142.251m3.713-.098V5.872h4.153v.93h-3.127v2.003h2.788v.92h-2.788v2.284h3.127v.93zm5.621 0V5.872h1.316l2.062 5.876-.048-.668q-.03-.387-.049-.804-.009-.416-.009-.755V5.871h.968v7.067h-1.317l-2.052-5.876q.02.252.039.629.029.378.038.784.02.407.02.755v3.707zm7.343 0V6.83h-1.888v-.968h4.821v.968h-1.888v6.109z"
      />
      <path
        fill="url(#d)"
        d="M241.735 12.938v-2.604l-2.101-4.463h1.084l1.249 2.672q.126.261.203.493.078.223.107.349.02-.126.097-.349.087-.232.203-.493l1.22-2.672h1.084l-2.101 4.463v2.604zm6.269.096q-.659 0-1.143-.242a1.8 1.8 0 0 1-.735-.716 2.3 2.3 0 0 1-.252-1.104V7.837q0-.64.252-1.103.261-.465.735-.707.484-.252 1.143-.252.657 0 1.132.252.484.242.736.707.261.465.261 1.093v3.147q0 .629-.261 1.103-.252.464-.736.716-.474.242-1.132.242m0-.929q.532 0 .803-.29.28-.3.281-.842V7.836q0-.551-.281-.842-.271-.29-.803-.29-.523 0-.804.29-.28.29-.281.842v3.137q0 .541.281.842.28.29.804.29m5.746.93q-1.017 0-1.568-.553-.552-.56-.552-1.52v-5.09h1.045v5.09q0 .533.262.843.27.31.813.31.533 0 .803-.31.271-.31.271-.842V5.87h1.046v5.092q0 .958-.552 1.52-.552.55-1.568.551m3.655-.098V5.872h2.217q.667 0 1.161.261.494.252.765.717.28.464.281 1.094 0 .705-.368 1.229a1.92 1.92 0 0 1-.978.726l1.443 3.04h-1.191l-1.287-2.905h-.998v2.905zm1.045-3.823h1.172q.522 0 .832-.31.31-.32.31-.842 0-.542-.31-.852t-.832-.31h-1.172zm10.05 3.823 1.801-7.066h1.374l1.801 7.067h-1.055l-.426-1.791h-2.004l-.426 1.79zm1.685-2.652h1.607l-.484-2.042a78 78 0 0 1-.213-.94q-.077-.405-.107-.551-.029.145-.106.552-.078.396-.213.929zm6.588 2.75q-.659 0-1.152-.243a1.84 1.84 0 0 1-.755-.716 2.25 2.25 0 0 1-.261-1.104V7.837q0-.64.261-1.103.271-.465.755-.707.494-.252 1.152-.252.659 0 1.142.252.484.252.746.716.27.455.271 1.094h-1.046q0-.551-.29-.842t-.823-.29-.832.29q-.291.29-.291.832v3.147q0 .541.291.842.3.3.832.3t.823-.3.29-.842v-.794h-1.316v-.92h2.362v1.713q0 .63-.271 1.094-.262.465-.746.717-.483.25-1.142.251m3.713-.098V5.872h4.153v.93h-3.127v2.003h2.788v.92h-2.788v2.284h3.127v.93zm5.621 0V5.872h1.316l2.062 5.876-.048-.668q-.03-.387-.049-.804-.009-.416-.009-.755V5.871h.968v7.067h-1.317l-2.052-5.876q.02.252.039.629.029.378.038.784.02.407.02.755v3.707zm7.343 0V6.83h-1.888v-.968h4.821v.968h-1.888v6.109z"
      />
      <g clipPath="url(#e)">
        <rect
          width="43.56"
          height=".726"
          x="214.557"
          y="43.258"
          fill="#dfe3e6"
          rx=".363"
          transform="rotate(90 214.557 43.258)"
        />
        <path fill="url(#f)" d="M214.555 43.258h23.958v.726h-23.958z" transform="rotate(90 214.555 43.258)" />
        <circle cx="214.192" cy="68.67" r="2.178" fill="#b7b7b7" transform="rotate(90 214.192 68.67)" />
      </g>
      <g clipPath="url(#g)">
        <rect
          width="43.56"
          height=".726"
          x="225.444"
          y="81.008"
          fill="#dfe3e6"
          rx=".363"
          transform="rotate(-90 225.444 81.008)"
        />
        <path fill="url(#h)" d="M225.446 81.008h23.958v.726h-23.958z" transform="rotate(-90 225.446 81.008)" />
        <circle cx="225.809" cy="55.595" r="2.178" fill="#b7b7b7" transform="rotate(-90 225.809 55.595)" />
      </g>
      <rect
        width="39.25"
        height="39.25"
        x="200.375"
        y="81.023"
        stroke="#fb3748"
        strokeOpacity=".16"
        strokeWidth=".75"
        rx="7.625"
      />
      <rect width="35.25" height="35.25" x="202.375" y="83.023" fill="#fff" rx="5.625" />
      <rect width="35.25" height="35.25" x="202.375" y="83.023" stroke="#dd2450" strokeWidth=".75" rx="5.625" />
      <path
        fill="url(#i)"
        fillRule="evenodd"
        d="M224.86 98.863a.54.54 0 0 1-.926.377l-6.928-7.081a9 9 0 0 1 2.994-.51c1.791 0 3.459.522 4.86 1.423zm2.52-3.367v3.367c0 2.742-3.329 4.099-5.247 2.139l-7.451-7.615a8.99 8.99 0 0 0-3.681 7.261c0 1.916.599 3.693 1.62 5.152v-3.349c0-2.742 3.329-4.1 5.247-2.139l7.44 7.604a8.98 8.98 0 0 0 3.692-7.268 8.96 8.96 0 0 0-1.62-5.152m-11.313 6.578 6.915 7.067a9 9 0 0 1-2.982.506 8.96 8.96 0 0 1-4.859-1.423v-5.773a.54.54 0 0 1 .926-.377"
        clipRule="evenodd"
      />
      <path
        fill="url(#j)"
        fillRule="evenodd"
        d="M224.86 98.863a.54.54 0 0 1-.926.377l-6.928-7.081a9 9 0 0 1 2.994-.51c1.791 0 3.459.522 4.86 1.423zm2.52-3.367v3.367c0 2.742-3.329 4.099-5.247 2.139l-7.451-7.615a8.99 8.99 0 0 0-3.681 7.261c0 1.916.599 3.693 1.62 5.152v-3.349c0-2.742 3.329-4.1 5.247-2.139l7.44 7.604a8.98 8.98 0 0 0 3.692-7.268 8.96 8.96 0 0 0-1.62-5.152m-11.313 6.578 6.915 7.067a9 9 0 0 1-2.982.506 8.96 8.96 0 0 1-4.859-1.423v-5.773a.54.54 0 0 1 .926-.377"
        clipRule="evenodd"
      />
      <path
        fill="url(#k)"
        fillRule="evenodd"
        d="M224.86 98.863a.54.54 0 0 1-.926.377l-6.928-7.081a9 9 0 0 1 2.994-.51c1.791 0 3.459.522 4.86 1.423zm2.52-3.367v3.367c0 2.742-3.329 4.099-5.247 2.139l-7.451-7.615a8.99 8.99 0 0 0-3.681 7.261c0 1.916.599 3.693 1.62 5.152v-3.349c0-2.742 3.329-4.1 5.247-2.139l7.44 7.604a8.98 8.98 0 0 0 3.692-7.268 8.96 8.96 0 0 0-1.62-5.152m-11.313 6.578 6.915 7.067a9 9 0 0 1-2.982.506 8.96 8.96 0 0 1-4.859-1.423v-5.773a.54.54 0 0 1 .926-.377"
        clipRule="evenodd"
      />
      <g clipPath="url(#l)">
        <rect
          width="43.56"
          height=".726"
          x="214.557"
          y="120.289"
          fill="#dfe3e6"
          rx=".363"
          transform="rotate(90 214.557 120.289)"
        />
        <path fill="url(#m)" d="M214.555 120.289h23.958v.726h-23.958z" transform="rotate(90 214.555 120.289)" />
        <circle cx="214.192" cy="145.701" r="2.178" fill="#b7b7b7" transform="rotate(90 214.192 145.701)" />
      </g>
      <g clipPath="url(#n)">
        <rect
          width="43.56"
          height=".726"
          x="225.444"
          y="158.039"
          fill="#dfe3e6"
          rx=".363"
          transform="rotate(-90 225.444 158.039)"
        />
        <path fill="url(#o)" d="M225.446 158.039h23.958v.726h-23.958z" transform="rotate(-90 225.446 158.039)" />
        <circle cx="225.809" cy="132.627" r="2.178" fill="#b7b7b7" transform="rotate(-90 225.809 132.627)" />
      </g>
      <rect width="440" height="88.184" y="157.672" fill="#fbfbfb" rx="11.616" />
      <rect width="140.536" height="36.88" x="4.356" y="162.031" stroke="#f2f5f8" strokeWidth=".968" rx="7.26" />
      <rect width="134.728" height="31.072" x="7.26" y="164.938" fill="#fff" rx="4.356" />
      <rect width="134.728" height="31.072" x="7.26" y="164.938" stroke="#e1e4ea" strokeWidth=".968" rx="4.356" />
      <path
        fill="#2eb67d"
        d="M27.162 179.935a1.14 1.14 0 1 0-1.16-1.12l.02 1.14zm-3.192.056a1.14 1.14 0 0 0 1.12-1.16l-.056-3.192a1.14 1.14 0 0 0-2.28.04l.056 3.192a1.14 1.14 0 0 0 1.16 1.12"
      />
      <path
        fill="#e01e5a"
        d="M17.602 181.018a1.14 1.14 0 1 0 1.16 1.12l-.02-1.14zm3.192-.056a1.14 1.14 0 0 0-1.12 1.16l.055 3.192a1.14 1.14 0 0 0 2.28-.04l-.055-3.192a1.14 1.14 0 0 0-1.16-1.12"
      />
      <path
        fill="#ecb22e"
        d="M22.921 185.256a1.14 1.14 0 1 0 1.12-1.16l-1.14.02zm-.056-3.192a1.14 1.14 0 0 0 1.16 1.12l3.192-.056a1.14 1.14 0 1 0-.04-2.28l-3.192.056a1.14 1.14 0 0 0-1.12 1.16"
      />
      <path
        fill="#36c5f0"
        d="M21.842 175.697a1.14 1.14 0 1 0-1.12 1.16l1.14-.02zm.055 3.192a1.14 1.14 0 0 0-1.16-1.12l-3.191.056a1.14 1.14 0 1 0 .04 2.28l3.191-.056a1.14 1.14 0 0 0 1.12-1.16"
      />
      <rect width="58.08" height="5.808" x="33.147" y="173.164" fill="url(#p)" rx="2.904" />
      <rect width="40.597" height="5.808" x="93.162" y="173.164" fill="url(#q)" rx="2.904" />
      <rect width="52.272" height="5.808" x="33.147" y="181.969" fill="url(#r)" rx="2.904" />
      <rect width="140.536" height="36.88" x="149.732" y="162.031" stroke="#f2f5f8" strokeWidth=".968" rx="7.26" />
      <rect width="134.728" height="31.072" x="152.636" y="164.938" fill="#fff" rx="4.356" />
      <rect width="134.728" height="31.072" x="152.636" y="164.938" stroke="#e1e4ea" strokeWidth=".968" rx="4.356" />
      <g clipPath="url(#s)">
        <path
          fill="url(#t)"
          d="M172.838 180.563a5.082 5.082 0 0 1-8.036 4.046l-1.745.404.485-1.699a5.083 5.083 0 1 1 9.296-2.751"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M167.654 186.397a5.929 5.929 0 1 0-5.106-3.094l-.822 2.991 3.11-.664a5.9 5.9 0 0 0 2.818.767m.016-.912a5.016 5.016 0 0 0 5.103-4.928 5.016 5.016 0 1 0-10.032-.175 5 5 0 0 0 .855 2.891l-.478 1.677 1.722-.399a5 5 0 0 0 2.83.934"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          d="M166.323 177.692c-.136-.285-.353-.264-.571-.268-.39-.007-1.007.45-1.022 1.321-.013.713.288 1.499 1.326 2.685 1.003 1.145 2.335 1.752 3.451 1.751 1.115 0 1.361-.955 1.367-1.279.002-.144-.086-.217-.147-.238-.377-.189-1.071-.541-1.23-.607-.158-.067-.243.018-.295.064-.147.135-.441.536-.541.626-.099.09-.245.041-.305.005-.223-.093-.825-.374-1.301-.852-.589-.591-.621-.791-.73-.971-.088-.144-.02-.23.013-.267a8 8 0 0 0 .396-.487c.082-.112.021-.287-.015-.396-.155-.467-.287-.858-.396-1.087"
        />
      </g>
      <rect width="38.72" height="5.808" x="178.522" y="173.164" fill="url(#u)" rx="2.904" />
      <rect width="35.816" height="5.808" x="219.179" y="173.164" fill="url(#v)" rx="2.904" />
      <rect width="90.024" height="5.808" x="178.522" y="181.969" fill="url(#w)" rx="2.904" />
      <rect width="140.536" height="36.88" x="295.108" y="162.031" stroke="#f2f5f8" strokeWidth=".968" rx="7.26" />
      <rect width="134.728" height="31.072" x="298.012" y="164.938" fill="#fff" rx="4.356" />
      <rect width="134.728" height="31.072" x="298.012" y="164.938" stroke="#e1e4ea" strokeWidth=".968" rx="4.356" />
      <path
        fill="url(#x)"
        d="M314.238 180.058a.33.33 0 0 1 .326-.337l4.154-.073a.33.33 0 0 1 .337.326l.042 2.398a2.41 2.41 0 0 1-4.817.084z"
      />
      <path
        fill="url(#y)"
        d="M310.523 179.505a.45.45 0 0 1 .441-.458l5.029-.088a.45.45 0 0 1 .458.442l.062 3.559a2.964 2.964 0 1 1-5.928.103z"
      />
      <ellipse cx="317.164" cy="177.839" fill="#34439e" rx="1.112" ry="1.101" transform="rotate(-1 317.164 177.839)" />
      <ellipse cx="317.164" cy="177.839" fill="url(#z)" rx="1.112" ry="1.101" transform="rotate(-1 317.164 177.839)" />
      <ellipse cx="313.817" cy="177.161" fill="url(#A)" rx="1.482" ry="1.468" transform="rotate(-1 313.817 177.161)" />
      <mask id="D" width="7" height="12" x="310" y="174" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }}>
        <path
          fill="url(#B)"
          d="M313.472 178.634a1.844 1.844 0 0 0 1.821-1.868 1.844 1.844 0 0 0-1.885-1.802 1.844 1.844 0 0 0-1.82 1.867 1.844 1.844 0 0 0 1.884 1.803"
        />
        <path
          fill="url(#C)"
          d="M310.969 179.044a.45.45 0 0 0-.446.458l.062 3.587c.029 1.622 1.379 2.913 3.016 2.884s2.941-1.366 2.912-2.987l-.062-3.587a.45.45 0 0 0-.462-.442z"
        />
      </mask>
      <g mask="url(#D)">
        <path
          fill="#000"
          fillOpacity=".3"
          d="M309.803 180.736a2.408 2.408 0 1 1 4.816-.084l.023 1.294a2.903 2.903 0 0 1-2.853 2.954l-1.913.034z"
        />
      </g>
      <rect
        width="6.67"
        height="6.607"
        x="307.154"
        y="177.648"
        fill="url(#E)"
        rx="1.936"
        transform="rotate(-1 307.154 177.648)"
      />
      <path fill="#fff" d="m311.996 179.026-2.964.052.012.673 1.11-.019.052 2.997.745-.013-.053-2.997 1.11-.019z" />
      <rect width="65.824" height="5.808" x="323.898" y="173.164" fill="url(#F)" rx="2.904" />
      <rect width="32.853" height="5.808" x="391.658" y="173.164" fill="url(#G)" rx="2.904" />
      <rect width="74.536" height="5.808" x="323.898" y="181.969" fill="url(#H)" rx="2.904" />
      <rect width="140.536" height="36.88" x="4.356" y="203.75" stroke="#f2f5f8" strokeWidth=".968" rx="7.26" />
      <rect width="134.728" height="31.072" x="7.26" y="206.657" fill="#fff" rx="4.356" />
      <rect width="134.728" height="31.072" x="7.26" y="206.657" stroke="#e1e4ea" strokeWidth=".968" rx="4.356" />
      <path
        fill="#24292f"
        fillRule="evenodd"
        d="M22.49 216.26c-3.281-.057-5.98 2.613-6.04 5.975-.046 2.687 1.613 4.991 3.957 5.837.293.065.405-.124.407-.285.003-.141.002-.624.01-1.127-1.656.333-1.981-.76-1.981-.76-.253-.709-.643-.897-.643-.897-.533-.381.046-.371.046-.371.599.05.903.639.903.639.514.936 1.373.689 1.72.534.056-.392.218-.661.387-.809-1.314-.164-2.69-.711-2.649-3.046a2.4 2.4 0 0 1 .638-1.62c-.056-.151-.252-.779.087-1.609 0 0 .504-.152 1.62.653a5.6 5.6 0 0 1 1.486-.176c.501.009 1.01.088 1.48.227 1.143-.765 1.642-.595 1.642-.595.31.841.092 1.461.03 1.611.376.43.593.977.58 1.641-.04 2.335-1.434 2.824-2.763 2.952.213.195.393.56.384 1.134-.015.815-.036 1.469-.04 1.67-.002.161.103.354.398.299 2.372-.764 4.11-3.009 4.158-5.695.068-3.362-2.546-6.125-5.817-6.182"
        clipRule="evenodd"
      />
      <rect width="28.072" height="5.808" x="33.147" y="214.883" fill="url(#I)" rx="2.904" />
      <rect width="31.944" height="5.808" x="63.154" y="214.883" fill="url(#J)" rx="2.904" />
      <rect width="84.216" height="5.808" x="33.147" y="223.688" fill="url(#K)" rx="2.904" />
      <rect width="140.536" height="37.752" x="149.732" y="203.75" stroke="#f2f5f8" strokeWidth=".968" rx="7.26" />
      <rect width="134.728" height="31.944" x="152.636" y="206.657" fill="#fff" rx="4.356" />
      <rect width="134.728" height="31.944" x="152.636" y="206.657" stroke="#e1e4ea" strokeWidth=".968" rx="4.356" />
      <g clipPath="url(#L)">
        <rect width="14.197" height="14.197" x="161.507" y="215.531" fill="url(#M)" rx="3.872" />
        <rect width="15.488" height="15.488" x="160.862" y="214.883" fill="#959595" rx="3.872" />
        <rect width="14.197" height="14.197" x="161.507" y="215.531" fill="url(#N)" rx="3.388" />
        <path
          fill="url(#O)"
          d="M166.5 225.624v-6.155h2.339q.719 0 1.205.246.49.247.74.692.253.441.253 1.03 0 .593-.256 1.028a1.7 1.7 0 0 1-.746.671q-.494.234-1.212.234h-1.665v-.926h1.513q.42 0 .688-.114a.8.8 0 0 0 .396-.34q.13-.225.131-.553 0-.327-.131-.559a.83.83 0 0 0-.399-.354q-.267-.123-.691-.124h-1.035v5.224zm3.222-2.789 1.544 2.789h-1.261l-1.517-2.789z"
        />
      </g>
      <rect width="54.208" height="5.808" x="180.224" y="215.32" fill="url(#P)" rx="2.904" />
      <rect width="35.816" height="5.808" x="236.367" y="215.32" fill="url(#Q)" rx="2.904" />
      <rect width="79.376" height="5.808" x="180.224" y="224.125" fill="url(#R)" rx="2.904" />
      <rect width="140.536" height="36.88" x="295.108" y="203.75" stroke="#f2f5f8" strokeWidth=".968" rx="7.26" />
      <rect width="134.728" height="31.072" x="298.012" y="206.657" fill="#fff" rx="4.356" />
      <rect width="134.728" height="31.072" x="298.012" y="206.657" stroke="#e1e4ea" strokeWidth=".968" rx="4.356" />
      <path
        fill="url(#S)"
        d="M307.139 218.492a2.116 2.116 0 0 1 2.08-2.154l7.622-.133a2.12 2.12 0 0 1 2.154 2.08l.133 7.622a2.12 2.12 0 0 1-2.08 2.154l-7.622.133a2.116 2.116 0 0 1-2.154-2.08z"
      />
      <path
        fill="url(#T)"
        d="M309.02 223.248a.08.08 0 0 1 .134-.075l3.146 3.038c.059.057.01.154-.07.136a4.24 4.24 0 0 1-3.21-3.099"
      />
      <path
        fill="url(#U)"
        d="M308.895 222.01a.09.09 0 0 0 .025.064l4.486 4.332a.09.09 0 0 0 .065.023q.3-.024.588-.089a.082.082 0 0 0 .038-.14l-4.995-4.824a.082.082 0 0 0-.139.043q-.054.29-.068.591"
      />
      <path
        fill="url(#V)"
        d="M309.226 220.548a.08.08 0 0 0 .019.093l5.581 5.39a.08.08 0 0 0 .094.016q.225-.105.435-.235a.084.084 0 0 0 .013-.131l-5.792-5.593a.084.084 0 0 0-.131.017 4 4 0 0 0-.219.443"
      />
      <path
        fill="url(#W)"
        d="M309.924 219.551a.084.084 0 0 1-.006-.115 4.24 4.24 0 1 1 6.089 5.88.084.084 0 0 1-.115-.001z"
      />
      <rect width="65.824" height="5.808" x="323.898" y="214.883" fill="url(#X)" rx="2.904" />
      <rect width="32.853" height="5.808" x="391.658" y="214.883" fill="url(#Y)" rx="2.904" />
      <rect width="74.536" height="5.808" x="323.898" y="223.688" fill="url(#Z)" rx="2.904" />
      <defs>
        <linearGradient id="a" x1="159.381" x2="263.813" y1="18.915" y2="18.915" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="b" x1="246.443" x2="289.496" y1="18.915" y2="18.915" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="c" x1="156.104" x2="279.524" y1="27.719" y2="27.719" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="d" x1="239.354" x2="297.341" y1="9.91" y2="10.798" gradientUnits="userSpaceOnUse">
          <stop stopColor="#939292" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
        <linearGradient id="f" x1="238.513" x2="214.555" y1="43.621" y2="43.621" gradientUnits="userSpaceOnUse">
          <stop stopColor="#b7b7b7" />
          <stop offset="1" stopColor="#b7b7b7" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="h" x1="249.404" x2="225.446" y1="81.371" y2="81.371" gradientUnits="userSpaceOnUse">
          <stop stopColor="#b7b7b7" />
          <stop offset="1" stopColor="#b7b7b7" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="j" x1="222.1" x2="220" y1="91.048" y2="109.647" gradientUnits="userSpaceOnUse">
          <stop offset=".085" stopColor="#ffba33" />
          <stop offset=".553" stopColor="#ff006a" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="k" x1="220" x2="220" y1="91.648" y2="109.647" gradientUnits="userSpaceOnUse">
          <stop offset=".547" stopOpacity="0" />
          <stop offset="1" stopOpacity=".6" />
        </linearGradient>
        <linearGradient id="m" x1="238.513" x2="214.555" y1="120.652" y2="120.652" gradientUnits="userSpaceOnUse">
          <stop stopColor="#b7b7b7" />
          <stop offset="1" stopColor="#b7b7b7" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="o" x1="249.404" x2="225.446" y1="158.402" y2="158.402" gradientUnits="userSpaceOnUse">
          <stop stopColor="#b7b7b7" />
          <stop offset="1" stopColor="#b7b7b7" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="p" x1="19.105" x2="100.481" y1="175.633" y2="175.633" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="q" x1="83.347" x2="140.228" y1="175.633" y2="175.633" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="r" x1="20.509" x2="93.748" y1="184.438" y2="184.438" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="t" x1="172.27" x2="162.587" y1="176.741" y2="185.467" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5bd066" />
          <stop offset="1" stopColor="#27b43e" />
        </linearGradient>
        <linearGradient id="u" x1="169.162" x2="223.412" y1="175.633" y2="175.633" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="v" x1="210.52" x2="260.702" y1="175.633" y2="175.633" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="w" x1="156.758" x2="282.891" y1="184.438" y2="184.438" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="x" x1="314.237" x2="319.14" y1="179.997" y2="183.11" gradientUnits="userSpaceOnUse">
          <stop stopColor="#364088" />
          <stop offset="1" stopColor="#6e7ee1" />
        </linearGradient>
        <linearGradient id="y" x1="310.568" x2="316.497" y1="182.139" y2="182.035" gradientUnits="userSpaceOnUse">
          <stop stopColor="#515fc4" />
          <stop offset="1" stopColor="#7084ea" />
        </linearGradient>
        <linearGradient id="z" x1="316.052" x2="318.186" y1="176.854" y2="178.37" gradientUnits="userSpaceOnUse">
          <stop stopColor="#364088" />
          <stop offset="1" stopColor="#6e7ee1" />
        </linearGradient>
        <linearGradient id="A" x1="312.758" x2="314.643" y1="176.112" y2="178.332" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4858ae" />
          <stop offset="1" stopColor="#4e60ce" />
        </linearGradient>
        <linearGradient id="B" x1="312.094" x2="314.498" y1="175.511" y2="178.245" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4858ae" />
          <stop offset="1" stopColor="#4e60ce" />
        </linearGradient>
        <linearGradient id="C" x1="312.094" x2="314.498" y1="175.511" y2="178.245" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4858ae" />
          <stop offset="1" stopColor="#4e60ce" />
        </linearGradient>
        <linearGradient id="E" x1="307.154" x2="313.824" y1="180.952" y2="180.952" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2a3887" />
          <stop offset="1" stopColor="#4c56b9" />
        </linearGradient>
        <linearGradient id="F" x1="307.985" x2="400.211" y1="175.633" y2="175.633" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="G" x1="383.716" x2="429.747" y1="175.633" y2="175.633" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="H" x1="305.879" x2="410.311" y1="184.438" y2="184.438" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="I" x1="26.36" x2="65.692" y1="217.352" y2="217.352" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="J" x1="55.432" x2="100.188" y1="217.352" y2="217.352" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="K" x1="12.787" x2="130.782" y1="226.157" y2="226.157" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="M" x1="168.606" x2="168.606" y1="210.996" y2="229.729" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4c4c57" />
          <stop offset=".444" stopColor="#05050a" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient id="N" x1="168.606" x2="168.606" y1="210.996" y2="229.729" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4c4c57" />
          <stop offset=".444" stopColor="#05050a" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient id="O" x1="166.708" x2="178.023" y1="219.982" y2="229.295" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="P" x1="167.118" x2="243.069" y1="217.789" y2="217.789" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="Q" x1="227.708" x2="277.89" y1="217.789" y2="217.789" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="R" x1="161.034" x2="272.247" y1="226.594" y2="226.594" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="S" x1="313.03" x2="313.237" y1="216.272" y2="228.128" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5c6bf1" />
          <stop offset="1" stopColor="#283188" />
        </linearGradient>
        <linearGradient id="T" x1="309.152" x2="320.935" y1="206.775" y2="223.414" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity=".65" />
        </linearGradient>
        <linearGradient id="U" x1="309.25" x2="316.693" y1="213.873" y2="224.384" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity=".65" />
        </linearGradient>
        <linearGradient id="V" x1="308.729" x2="315.034" y1="216.3" y2="225.204" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity=".65" />
        </linearGradient>
        <linearGradient id="W" x1="309.141" x2="313.67" y1="218.82" y2="225.216" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity=".65" />
        </linearGradient>
        <linearGradient id="X" x1="307.985" x2="400.211" y1="217.352" y2="217.352" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="Y" x1="383.716" x2="429.747" y1="217.352" y2="217.352" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <linearGradient id="Z" x1="305.879" x2="410.311" y1="226.157" y2="226.157" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f1efef" />
          <stop offset=".48" stopColor="#f9f8f8" />
          <stop offset=".992" stopColor="#f9f8f8" stopOpacity=".75" />
        </linearGradient>
        <clipPath id="e">
          <path fill="#fff" d="M217.822 43.258V81.01h-7.26V43.258z" />
        </clipPath>
        <clipPath id="g">
          <path fill="#fff" d="M222.179 81.008V43.256h7.26v37.752z" />
        </clipPath>
        <clipPath id="l">
          <path fill="#fff" d="M217.822 120.289v37.752h-7.26v-37.752z" />
        </clipPath>
        <clipPath id="n">
          <path fill="#fff" d="M222.179 158.039v-37.752h7.26v37.752z" />
        </clipPath>
        <clipPath id="s">
          <path fill="#fff" d="m161.101 173.578 13.55.237-.237 13.55-13.55-.237z" />
        </clipPath>
        <clipPath id="L">
          <path fill="#fff" d="M160.864 214.883h15.488v15.488h-15.488z" />
        </clipPath>
        <radialGradient
          id="i"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(135 89.155 95.887)scale(12.7272)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".34" stopColor="#ff006a" />
          <stop offset=".613" stopColor="#e300bd" />
          <stop offset=".767" stopColor="#ff4ce1" />
        </radialGradient>
      </defs>
    </svg>
  );
}
